import React, { ButtonHTMLAttributes } from "react";
import "./button.module.css";

type ColorValue = string;

export interface ButtonUIProps {
    uiFlat?: boolean;
    uiColor?: ColorValue;
    uiTextColor?: ColorValue;
    uiDisabled?: boolean;
    uiActive?: boolean;
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & ButtonUIProps;

const Button: React.FC<ButtonProps> = ({
    uiFlat,
    uiColor,
    uiTextColor,
    uiDisabled,
    uiActive,
    className,
    children,
    style,
    ...rest
}) => {
    const { disabled, ...otherProps } = rest;
    const classNames = [
        "btn",
        uiFlat ? "btn-flat" : "",
        uiActive ? "btn-active" : "",
        uiDisabled || disabled ? "btn-disabled" : "",
        className,
    ]
    .filter(Boolean)
    .join(" ");

    const inlineStyles: React.CSSProperties = {
        ...style,
    };

    if (uiColor) {
        if (uiFlat) {
            inlineStyles.color = uiColor;
        } else {
            inlineStyles.backgroundColor = uiColor;
        }
    }

    if (uiTextColor) {
        inlineStyles.color = uiTextColor;
    }

    return (
        <button
            className={classNames}
            style={inlineStyles}
            disabled={disabled}
            aria-disabled={uiDisabled || disabled}
            {...otherProps}
        >
            {children}
        </button>
    );
};

export default Button;
